import './Header.css';
import { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import UserForm from '../UserForm/UserForm';
import siteSlice from '../../redux/siteSlice';
import workersSlice from '../../redux/workersSlice';
import locationsSlice from '../../redux/locationsSlice';
import notesSlice from '../../redux/notesSlice';
import { editWorkplace, getAllData } from '../../utils/api';

const cleanText = (text) => {
  if (typeof text !== 'string') return text;
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line !== '')
    .join('\n')
    .trim();
};

export default function Header() {
  const dispatch = useDispatch();

  const { switchEdit, selectForm } = {
    switchEdit: () => dispatch(siteSlice.actions.switchEdit()),
    selectForm: (form) => dispatch(siteSlice.actions.selectForm(form)),
  };

  const { clearUser, clearWorkers, clearLocations, clearNotes } = {
    clearUser: () => dispatch(siteSlice.actions.clearUser()),
    clearWorkers: () => dispatch(workersSlice.actions.clearWorkers()),
    clearLocations: () => dispatch(locationsSlice.actions.clearLocations()),
    clearNotes: () => dispatch(notesSlice.actions.clearNotes()),
  };

  const { site, workers, locations, notes } = {
    site: useSelector((state) => state.site),
    workers: useSelector((state) => state.workers.value),
    locations: useSelector((state) => state.locations.value),
    notes: useSelector((state) => state.notes.value),
  };

  const selectSignin = () => {
    if (site.selectedForm !== 'signin') {
      selectForm('signin');
    } else {
      selectForm('');
    }
  };

  const selectSignup = () => {
    if (site.selectedForm !== 'signup') {
      selectForm('signup');
    } else {
      selectForm('');
    }
  };

  const onDevMode = async () => {
    Cookies.set('token', 'dev-token');
    try {
      const { user, workplace } = await getAllData();
      dispatch(siteSlice.actions.setUser(user));
      dispatch(workersSlice.actions.setWorkers(workplace.workers));
      dispatch(locationsSlice.actions.setLocations(workplace.locations));
      dispatch(notesSlice.actions.setNotes(workplace.notes));
    } catch (err) {
      console.error('Failed to load dev data:', err);
      dispatch(siteSlice.actions.setUser({
        email: 'dev@workweek.com',
        workplace: 'Dev Workplace',
        isAdmin: true,
        id: 'dev-id',
      }));
    }
  };

  const onSignOut = () => {
    Cookies.remove('token');
    clearUser();
    clearWorkers();
    clearLocations();
    clearNotes();
    window.location.reload();
  };

  const onEditClick = () => {
    const token = Cookies.get('token');
    if (site.isEdit) {
      const cleanedWorkers = workers.map((w) => ({
        ...w,
        name: cleanText(w.name),
        days: {
          morning: w.days.morning.map(cleanText),
          night: w.days.night.map(cleanText),
        },
      }));
      const cleanedLocations = locations.map((l) => ({
        ...l,
        name: cleanText(l.name),
        days: l.days.map(cleanText),
      }));
      const cleanedNotes = notes.map((n) => ({
        ...n,
        text: cleanText(n.text),
      }));

      dispatch(workersSlice.actions.setWorkers(cleanedWorkers));
      dispatch(locationsSlice.actions.setLocations(cleanedLocations));
      dispatch(notesSlice.actions.setNotes(cleanedNotes));

      if (token !== 'dev-token') {
        editWorkplace({
          workers: cleanedWorkers,
          locations: cleanedLocations,
          notes: cleanedNotes,
        });
      }
    }
    switchEdit();
  };

  const onCancelClick = () => {
    switchEdit();
    window.location.reload();
  };

  return (
    <header className='header'>
      <h1 href='/header' className='header__title'>
        WorkWeek
      </h1>

      {site.user.email ? (
        <Fragment>
          <p className='header__workplace'>{site.user.workplace}</p>
          <div className='header__buttons'>
            {site.isEdit && (
              <button
                onClick={onCancelClick}
                className='header__button header__button_active header__button_cancel'
              >
                בטל
              </button>
            )}
            {site.user.isAdmin && (
              <button
                onClick={onEditClick}
                className={`header__button ${
                  site.isEdit && 'header__button_active'
                }`}
              >
                {site.isEdit ? 'שמור' : 'עריכה'}
              </button>
            )}
            <button onClick={onSignOut} className='header__button'>
              התנתק
            </button>
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <div className='header__buttons'>
            <button
              onClick={onDevMode}
              className='header__button header__button_dev'
            >
              Dev
            </button>
            <button
              onClick={selectSignin}
              className={`header__button ${
                site.selectedForm === 'signin' && 'header__button_active'
              }`}
            >
              התחבר
            </button>
            <button
              onClick={selectSignup}
              className={`header__button ${
                site.selectedForm === 'signup' && 'header__button_active'
              }`}
            >
              הרשמה
            </button>
          </div>
          {<UserForm />}
        </Fragment>
      )}
    </header>
  );
}
